__turbopack_context__.v({
  "explore_btn": "DegreeProgramWithFilter2-module-scss-module__lPaAaW__explore_btn",
  "heading": "DegreeProgramWithFilter2-module-scss-module__lPaAaW__heading",
  "heading_text": "DegreeProgramWithFilter2-module-scss-module__lPaAaW__heading_text",
  "root": "DegreeProgramWithFilter2-module-scss-module__lPaAaW__root",
});
